import * as schemas from "~/schemas/schema.files";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { encodeData } from "~/utils/utils.jsx";
import * as trashActions from "./actions.trash.jsx";

export const fetchFile = (id, projectId) => {
  return {
    types: [actionTypes.FETCH_FILE_LOADING, actionTypes.FETCH_FILE_SUCCESS, actionTypes.FETCH_FILE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/files/${id}`,
      }),
    payload: {
      projectId,
      id,
      schema: {
        single: schemas.file,
      },
    },
  };
};

export const fetchFiles = (projectId, folderId, cursor, signal, limit) => {
  const values = {
    limit: limit ?? 50,
  };

  if (cursor && cursor > 0) {
    values.cursor = cursor;
  }

  let query = encodeData(values);

  if (query) {
    query = "?" + query;
  }

  return {
    types: [actionTypes.FETCH_FILES_LOADING, actionTypes.FETCH_FILES_SUCCESS, actionTypes.FETCH_FILES_ERROR],
    callAPI: () => {
      const path = folderId
        ? `${Angie.api_url}/projects/${projectId}/folders/${folderId}/files${query}`
        : `${Angie.api_url}/projects/${projectId}/folders/files${query}`;
      return fetch({
        url: path,
        withHeaders: true,
        signal,
      });
    },
    payload: {
      projectId,
      folderId,
      schema: schemas.arrayOfFiles,
    },
  };
};

export const addFiles = (projectId, folderId, attributes, signal) => {
  return {
    types: [actionTypes.ADD_FILES_LOADING, actionTypes.ADD_FILES_SUCCESS, actionTypes.ADD_FILES_ERROR],
    callAPI: () => {
      const path = folderId
        ? `${Angie.api_url}/projects/${projectId}/folders/${folderId}/files`
        : `${Angie.api_url}/projects/${projectId}/files/batch`;
      return fetch({
        method: "POST",
        url: path,
        body: attributes,
        signal,
      });
    },
    payload: {
      projectId,
      folderId,
      schema: schemas.arrayOfFiles,
    },
  };
};

export const editFile = (id, projectId, attributes) => {
  return {
    types: [actionTypes.EDIT_FILE_LOADING, actionTypes.EDIT_FILE_SUCCESS, actionTypes.EDIT_FILE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/files/${id}`,
        method: `PUT`,
        body: attributes,
      }),
    payload: {
      id,
      projectId,
      attributes,
      schema: {
        single: schemas.file,
      },
    },
  };
};

export const moveFile = (id, projectId, targetFolderId) => {
  return {
    types: [actionTypes.MOVE_FILE_LOADING, actionTypes.MOVE_FILE_SUCCESS, actionTypes.MOVE_FILE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/files/${id}/move-to-folder`,
        method: "PUT",
        body: {
          target_folder_id: targetFolderId,
        },
      }),
    payload: {
      id,
      projectId,
      targetFolderId,
      schema: {
        single: schemas.file,
      },
    },
  };
};

export const moveFileToTrash = (id) => {
  const { payload, ...rest } = trashActions.moveToTrash("File", id);
  return {
    ...rest,
    payload: {
      ...payload,
      schema: {
        single: schemas.file,
      },
    },
  };
};

export const restoreFileFromTrash = (id) => {
  const { payload, ...rest } = trashActions.restoredFromTrash("File", id);
  return {
    ...rest,
    payload: {
      ...payload,
      schema: {
        single: schemas.file,
      },
    },
  };
};
